// FIXME: Refactor storages to rely on wall footprints only
export enum StoragePosition {
  Back = 'back',
  Front = 'front',
  Left = 'left',
  Right = 'right',
}
